function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModuleBase from "./ModuleBase";
import ModuleBaseLink from "./ModuleLink";
import ModuleActionPrimary from "./ModuleActionPrimary";
import ModuleActionbar from "./ModuleActionbar";
import ModuleMedia from './ModuleMedia';
import ModuleTitle from './ModuleTitle';
import ModuleLabel from './ModuleLabel';
import ModuleMetadata from './ModuleMetadata';
import ModuleDescription from './ModuleDescription';
import ModuleStatus from './ModuleStatus';
import ModuleByline from './ModuleByline';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {
    position: "relative",
    display: "flex",
    width: "100%",
    minHeight: theme.spacing(8),
    justifyContent: "flex-start",
    alignItems: "center",
    userSelect: "none",
    "&[role=button]": {
      cursor: "pointer",
      "& *": {
        pointerEvents: "none"
      }
    },
    "&[data-elevated=true]": {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    },
    "& + $root": {
      borderTop: "1px solid",
      borderColor: theme.palette.divider
    },
    "&.sortable-helper": {
      borderTopColor: "transparent",
      boxShadow: theme.shadows[12],
      zIndex: 2000,
      "& $trailingIcons": {
        display: "none"
      }
    },
    "&[data-status=erased]": {
      "& figure": {
        opacity: "0.5"
      },
      "& $content": {
        opacity: "0.5"
      }
    },
    "&[data-status=trash]": {
      "& figure": {
        opacity: "0.5"
      },
      "& $content": {
        opacity: "0.5"
      }
    }
  },
  item: {
    display: "flex",
    width: "100%",
    justifyContent: "flex-start",
    alignItems: "center",
    userSelect: "none"
  },
  actionbar: {
    zIndex: 3,
    display: "flex"
  },
  body: {},
  media: {
    display: "flex"
  },
  content: {
    width: "100%",
    maxWidth: "100%",
    flexDirection: "column",
    overflow: "hidden",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    margin: theme.spacing(1)
  },
  header: {
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    display: "flex",
    alignItems: "baseline",
    justifyContent: "flex-start",
    "& * + *": {
      marginLeft: theme.spacing(.5)
    }
  },
  footer: {
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    display: "flex",
    alignItems: "baseline",
    justifyContent: "flex-start",
    "& * + *": {
      marginLeft: theme.spacing(.5)
    }
  },
  uploadProgress: {
    position: "absolute",
    zIndex: 2,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  progress: {
    position: "absolute",
    backgroundColor: theme.palette.primary.main,
    //        opacity: 0.25,
    height: theme.spacing(.25),
    top: "auto",
    right: "auto",
    bottom: 0,
    left: 0,
    width: props => {
      return props.uploadProgress + "%";
    }
  }
}));

const ListModule = (_ref) => {
  let uploadProgress = _ref.uploadProgress,
      imageUrl = _ref.imageUrl,
      untitled = _ref.untitled,
      typeLabel = _ref.typeLabel,
      type = _ref.type,
      title = _ref.title,
      description = _ref.description,
      metadata = _ref.metadata,
      status = _ref.status,
      statusLabel = _ref.statusLabel,
      author = _ref.author,
      datetime = _ref.datetime,
      onClick = _ref.onClick,
      onEdit = _ref.onEdit,
      props = _objectWithoutPropertiesLoose(_ref, ["uploadProgress", "imageUrl", "untitled", "typeLabel", "type", "title", "description", "metadata", "status", "statusLabel", "author", "datetime", "onClick", "onEdit"]);

  const classes = useStyles({
    uploadProgress: uploadProgress
  });
  return React.createElement(ModuleBase, _extends({}, props, {
    className: classes.root,
    status: status,
    onClick: onClick
  }), React.createElement("div", {
    className: classes.item
  }, React.createElement(ModuleActionPrimary, props), React.createElement("div", {
    className: classes.media
  }, React.createElement(ModuleMedia, {
    imageUrl: imageUrl,
    width: "48px",
    height: "48px"
  })), React.createElement("div", {
    className: classes.content
  }, React.createElement("header", {
    className: classes.header
  }, React.createElement(ModuleTitle, {
    status: status,
    untitled: untitled,
    title: title,
    onClick: !onClick && onEdit
  }), React.createElement(ModuleStatus, {
    statusLabel: statusLabel,
    status: statusLabel || status
  }), React.createElement(ModuleByline, {
    author: author,
    datetime: datetime
  })), React.createElement("footer", {
    className: classes.footer
  }, React.createElement(ModuleLabel, {
    label: typeLabel || type
  }), React.createElement(ModuleMetadata, {
    metadata: metadata
  }), React.createElement(ModuleDescription, {
    description: description
  }))), uploadProgress && React.createElement("div", {
    className: classes.uploadProgress
  }, React.createElement("div", {
    className: classes.progress
  })), React.createElement(ModuleActionbar, _extends({}, props, {
    className: classes.actionbar
  }))));
};

ListModule.propTypes = process.env.NODE_ENV !== "production" ? {
  imageUrl: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.string,
  typeLabel: PropTypes.string,
  metadata: PropTypes.array,
  status: PropTypes.string,
  statusLabel: PropTypes.string,
  author: PropTypes.string,
  datetime: PropTypes.string,
  onClick: PropTypes.func,
  onEdit: PropTypes.func
} : {};
ListModule.defaultProps = {
  size: "small"
};
export default ListModule;